import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { MatLegacyPaginator as MatPaginator } from '@angular/material/legacy-paginator';
import { Router } from '@angular/router';
import { Lightbox } from 'ngx-lightbox';
import { CollectionHelper } from 'src/app/helpers/collection-helper';
import DateHelper from 'src/app/helpers/date-helper';
import { SubProjectImmoNonExecuted } from 'src/app/model/project/sub-project-immo-non-executed';
import { ProperPageResult } from 'src/app/model/proper-page-result';
import { SubProjectControllerRequestService } from 'src/app/services/api/sub-project-controller-request.service';
import { FilterStoreService } from 'src/app/services/filter-store.service';
import { ModalService } from 'src/app/services/modal.service';
import { PageIndexService } from 'src/app/services/page-index-service';
import { SnackService } from 'src/app/services/snack.service';
import { AbstractImmoOverviewComponent } from '../abstract-immo-overview.component';

@Component({
  selector: 'non-executed-immo-overview',
  templateUrl: '../abstract-immo-overview.component.html',
  styleUrls: ['../abstract-immo-overview.component.scss'],
})
export class NonExecutedImmoOverviewComponent
  extends AbstractImmoOverviewComponent<SubProjectImmoNonExecuted>
  implements OnInit
{
  @Output()
  countChange = new EventEmitter<number>();

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  constructor(
    protected filterStoreService: FilterStoreService,
    protected pageIndexService: PageIndexService,
    protected cd: ChangeDetectorRef,
    protected subProjectService: SubProjectControllerRequestService,
    protected _lightbox: Lightbox,
    protected router: Router,
    private modalService: ModalService,
    private snackService: SnackService
  ) {
    super(
      [
        {
          key: 'project__id',
          active: false,
          strictEquality: true,
          numeric: true,
        },
        {
          key: 'currentCreatedAt',
          active: false,
          strictEquality: true,
          numeric: false,
        },
        {
          key: 'immoNewCustomerName',
          active: false,
          strictEquality: false,
          numeric: false,
        },
        {
          key: 'projectPlacement__address__line1',
          active: false,
          strictEquality: false,
          numeric: false,
        },
      ],
      filterStoreService,
      pageIndexService,
      cd,
      subProjectService,
      _lightbox,
      router
    );

    super.showRelease = true;
    super.showInvoiceAsNonExecuted = true;
  }
  public override openTour(subProject: SubProjectImmoNonExecuted): void {
    throw new Error('Method not implemented.');
  }
  public override copyProjectId(subProject: SubProjectImmoNonExecuted): void {
    throw new Error('Method not implemented.');
  }
  protected override getPaginator(): MatPaginator {
    return this.paginator;
  }

  protected override getLocalStorageKey(): string {
    return 'NonExecutedImmoOverviewComponent';
  }

  protected override initDisplayedColumns(): void {
    this.displayedColumns = [
      'projectId',
      'request',
      'notExecutedHistoryItemDate',
      'notExecutedHistoryItemAuthor',
      'customerName',
      'addressWithFloor',
      'installerFeedback',
      'kind',
      'measurements',
      'type',
      'subProjectPhotos',
      'displayStatus',
    ];
  }

  protected override initSortSettings(): void {
    this.sortColumn = 'currentCreatedAt';
    this.sortAscending = false;
  }

  protected override fetchItems() {
    this.loading = true;
    this.items = [];

    this.subProjectService
      .getImmoNonExecuted(
        this.generateFilterString(),
        this.sortColumn,
        this.sortAscending,
        this.paginator.pageSize,
        this.paginator.pageIndex,
        false
      )
      .then((res) => {
        this.processPageResult(res);
        this.totalItems = res.totalItems;
        this.countChange.emit(this.totalItems);
        this.processItems(res);
        this.items = res.items;
      })
      .finally(() => {
        this.loading = false;
      });
  }

  private processItems(res: ProperPageResult<SubProjectImmoNonExecuted>) {
    if (CollectionHelper.isPopulated(res.items)) {
      res.items.forEach((sp) => {
        sp.statusClass = sp.nonStandard ? 'new' : 'non-executed';
        sp.currentCreatedAtDisplay =
          sp.currentCreatedAt == null
            ? null
            : DateHelper.formatDate(sp.currentCreatedAt);
        if (
          sp.project != null &&
          CollectionHelper.isPopulated(sp.project.ipBoards)
        ) {
          sp.project.firstIpBoard = sp.project.ipBoards[0];
        }
      });
    }
  }

  public override openProject(subProject: SubProjectImmoNonExecuted): void {
    this.router.navigate([
      '/job',
      subProject.project == null ? null : subProject.project.id,
      subProject.id,
    ]);
  }

  public release(subProject: SubProjectImmoNonExecuted): void {
    this.modalService.confirmDialog(
      'Vrijgeven',
      'Weet u zeker dat u deze job wilt vrijgeven?',
      (c) => {
        if (c) {
          this.subProjectService.release(subProject.id).then(() => {
            this.snackService.showSuccess('Job is succesvol vrijgegeven');
            this.fetchItems();
          });
        }
      }
    );
  }

  public setInvoiceAsNonExecuted(subProject: SubProjectImmoNonExecuted): void {
    this.modalService.confirmDialog(
      'Deels factureren',
      'Weet u zeker dat u deze job deels wilt laten factureren?',
      (c) => {
        if (c) {
          this.subProjectService
            .setInvoiceAsNonExecuted(subProject.id)
            .then(() => {
              this.snackService.showSuccess(
                'Job succesvol gemarkeerd als deels te factureren'
              );
              this.fetchItems();
            });
        }
      }
    );
  }

  public archive(subProject: SubProjectImmoNonExecuted): void {
    this.modalService.confirmDialog(
      'Verwijderen',
      'Weet u zeker dat u deze job wilt verwijderen?',
      (c) => {
        if (c) {
          this.subProjectService.archive(subProject.id).then(() => {
            this.snackService.showSuccess('Verwijdering succesvol');
            this.fetchItems();
          });
        }
      }
    );
  }
}
